import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => {
  return {
    containerTabsScroller:{
        padding: "0px 32px 0px 32px",
    }
}})